import { IOwner } from "src/app/core/interfaces";

export interface OwnerStateModel {
  owners: IOwner[];
  isOwnersLoading: boolean;
  isOwnerLoading: boolean;
  isGovIdUpdating: boolean;
}

export const defaultOwnerState: OwnerStateModel = {
  owners: [],
  isOwnersLoading: false,
  isOwnerLoading: false,
  isGovIdUpdating: false,
};
